import html2canvas from './html2canvas'
import PrintJS from 'print-js'

// 打印类属性、方法定义
/* eslint-disable */
export const Print = function (dom, options = {}) {
  if(!dom) {
    dom = '.flow-print'
  }
  let cloneDom = null
  let imgmap = null
  if ((typeof dom) === "string") {
    cloneDom = document.querySelector(dom);
  } else {
    this.isDOM(dom)
    cloneDom = this.isDOM(dom) ? dom : dom.$el;
  }
  cloneDom
  //主要修改：将打印的dom转换成图片
  html2canvas(cloneDom, {
    scale: 2,
    backgroundColor: '#f6f8fc',
    allowTaint: true,  //开启跨域
    useCORS: true,
    ignoreElements: (element) => element.attributes && element.attributes.hidecanvas,
    width: cloneDom.offsetWidth,
    height: cloneDom.offsetHeight,
  }).then(canvas => {
      imgmap = canvas.toDataURL("image/png");
      const style = '@media print { @page {size: auto; margin: 0; } body{margin:0 5px}}' ;
      PrintJS({
        printable: imgmap,
        width: cloneDom.offsetWidth,
        height: cloneDom.offsetHeight,
        type: "image",
        maxWidth: 200,
        style: style, // 去除页眉页脚
        ...options
      })
  })
};
const MyPlugin = {}
MyPlugin.install = function (Vue, options) {
  // 4. 添加实例方法
  Vue.prototype.$print = Print
}
export default MyPlugin